// extracted by mini-css-extract-plugin
export default {"filterBox":"ClassifiedFilter_filterBox__7BO6+","CrossIcon":"ClassifiedFilter_CrossIcon__nBzZe","cancelIcon":"ClassifiedFilter_cancelIcon__ZNzYq"};